import * as React from "react";
import { Box, FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

const Checklist = ({ label, hideLabel, selectedValues, options, onChange, columns = 1, ...rest }) => {
    const handleChange = (event) => {
        if (event.target.checked) {
            selectedValues.push(event.target.name);
        } else {
            selectedValues.splice(selectedValues.indexOf(event.target.name), 1);
        }

        onChange(event, selectedValues);
    };

    return (
        <FormControl component="fieldset" rest variant="standard" sx={{ width: "100%" }}>
            {!hideLabel && <FormLabel component="legend">{label}</FormLabel>}
            <FormGroup>
                {options.length > 0 && (
                    <Grid container>
                        {options.map((item) => (
                            <Grid item xs={12} md={12 / columns}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={selectedValues.indexOf(item.value) > -1}
                                            onChange={handleChange}
                                            name={item.value}
                                        />
                                    }
                                    label={item.label}
                                />
                            </Grid>
                        ))}
                    </Grid>
                )}
            </FormGroup>
        </FormControl>
    );
};

export { Checklist };
